import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-kebab-menu-vertical-blue',
    templateUrl: './kebab-menu-vertical-blue.component.svg',
    styleUrls: ['./kebab-menu-vertical-blue.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KebabMenuVerticalBlueComponent {}
